<template>
	<div class="CommissionSettlementDetails">
		<div class="CommissionSettlementDetails-content">
			<div class="margin-top1" style="overflow: hidden;">
				<el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
					<el-form-item label="状态" prop="type">
						<el-select v-model="ruleForm.type" placeholder="选择状态">
							<el-option v-for="(item, index) in staff" :key="index" :label="item.name"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="月份" prop="type">
						<el-select v-model="ruleForm.salaryMonth" placeholder="选择月份">
							<el-option v-for="(item, index) in month" :key="index" :label="item.name"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="开始日期" prop="starttime">
						<el-date-picker style="width:210px;" v-model="ruleForm.starttime" type="datetime"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="选择开始日期"></el-date-picker>
					</el-form-item>

					<el-form-item label="结束日期" prop="endtime">
						<el-date-picker style="width:210px;" v-model="ruleForm.endtime" type="datetime"
							format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="选择结束日期"></el-date-picker>
					</el-form-item>

					<el-form-item prop="type" style="width: 70%;" class="searchInput">
						<el-input v-model="ruleForm.input" placeholder="用户名" style="width: 50%;"></el-input>
						<el-button type="primary" style="margin-left: 15px;" class="search"
							@click="search2">搜索</el-button>
						<el-button type="primary" class="search" @click="searchReset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<div>
				<el-button type="primary" @click="open">薪资结算</el-button>
			</div>

			<div style="margin-top:15px;">
				<table border="0" cellpadding="0" width="100%" class="table-box layout_table">
					<thead>
						<tr>
							<td :colspan="RateList.length" class="RoteName">
								今日汇率
							</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th v-for="(item, i) in RateList" :key="i">
								{{ item.country }}
							</th>
						</tr>
						<tr>
							<td v-for="(item, i) in RateList" :key="i">
								{{ item.exchangeRate }}
							</td>
						</tr>
					</tbody>
				</table>

				<el-table :data="tableData" border style="width: 100%;margin-top:20px;font-size:13px;"
					v-loading="loading">
					<el-table-column prop="userName" label="用户名" align="center" fixed="left"></el-table-column>
					<el-table-column label="状态" align="center">
						<template slot-scope="scope">
							<span v-if="scope.row.state == 0">删除</span>
							<span v-if="scope.row.state == 1">未提交</span>
							<span v-if="scope.row.state == 2">未审核</span>
							<span v-if="scope.row.state == 3">已发放</span>
							<span v-if="scope.row.state == 4">审核失败</span>
						</template>
					</el-table-column>
					<el-table-column width="50" prop="salaryMonth" label="薪资月份" align="center"></el-table-column>
					<el-table-column width="105" prop="cycle" label="提成结算周期" align="center"></el-table-column>
					<el-table-column width="104" prop="settlementDate" label="结算日期" align="center"></el-table-column>

					<el-table-column prop="basicWage" label="基本工资" align="center"></el-table-column>
					<el-table-column prop="incentiveBonus" label="学历津贴" align="center"></el-table-column>
					<el-table-column prop="financialReimbursement" label="岗位工资" align="center"></el-table-column>
					<el-table-column prop="perfectAttendanceAward" label="全勤奖" align="center"></el-table-column>
					<el-table-column prop="otherSubsidies" label="奖励" align="center"></el-table-column>
					<el-table-column prop="supervisorCommission" label="提成" align="center"></el-table-column>
					<el-table-column prop="groupCommission" label="小组提成" align="center"></el-table-column>
					<el-table-column prop="jobsWage" label="补助" align="center"></el-table-column>
					<el-table-column prop="commission" label="主管提成" align="center"></el-table-column>
					<el-table-column prop="reissue" label="补发" align="center"></el-table-column>
					<el-table-column prop="payable" label="应发工资" align="center"></el-table-column>
					<el-table-column prop="operationalDeduction" label="运营扣款" align="center"></el-table-column>
					<el-table-column prop="attendanceDeduction" label="考勤扣款" align="center"></el-table-column>
					<el-table-column prop="otherDeduction" label="职工保险代缴扣款" align="center"></el-table-column>
					<el-table-column prop="paidWage" label="实发工资" align="center" fixed="right"></el-table-column>
					<el-table-column prop="remarks" label="备注" align="center"></el-table-column>
					<el-table-column label="操作" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="primary" @click="Edit(scope.row)"><i class="el-icon-edit"></i></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<el-dialog title="薪资结算" :visible.sync="settlement_steps1" width="65%">
				<div>
					<label>选择月份：</label>
					<el-select v-model="Setform.salaryMonth" placeholder="选择月份">
						<el-option v-for="(item, index) in month" :key="index" :label="item.name"
							:value="item.value"></el-option>
					</el-select>
				</div>
				<div style="margin-top:15px;">
					<label>选择用户：</label>
					<el-select v-model="Setform.user" placeholder="选择用户" filterable>
						<el-option v-for="(item, index) in userList" :key="index" :label="item.userName"
							:value="item.uid"></el-option>
					</el-select>
				</div>
				<div style="margin-top:15px;">
					提成结算时间
				</div>
				<div style="margin-top:15px;">
					<label>开始时间：</label>
					<el-date-picker style="width:210px;" v-model="Setform.starttime" type="datetime"
						:picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
						placeholder="选择开始日期"></el-date-picker>

					<label style="margin-left:20px;">结束时间：</label>
					<el-date-picker style="width:210px;" v-model="Setform.endtime" type="datetime"
						:picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss"
						placeholder="选择结束日期"></el-date-picker>
				</div>
				<div style="margin-top:15px;">
					<label>被结算月当月的结算日期</label>
					<el-input style="width:100px;margin:10px;text-align:center" disabled
						v-model="Setform.settlementTime"></el-input>
					<span>日</span>
				</div>
				<div style="margin-top:15px;">
					<table border="0" cellpadding="0" width="100%" class="table-box layout_table">
						<!-- <thead>
                        <tr>
                            <td colspan="12" class="RoteName">今日汇率</td>
                        </tr>
                        </thead> -->
						<tbody>
							<tr>
								<th style="text-align: center;">
									国家
								</th>
								<th>
									汇率
								</th>
							</tr>
							<tr v-for="(item, i) in RateList1" :key="i">
								<td style="text-align: center;">
									{{ item.country }}
								</td>
								<td>
									<el-input v-model="item.exchangeRate"></el-input>
								</td>
							</tr>
							<!-- <tr>
								<th v-for="(item, i) in RateList1" :key="i">
									{{ item.country }}
								</th>
							</tr>
							<tr>
								<td v-for="(item, i) in RateList1" :key="i">
									<el-input
										v-model="item.exchangeRate"
									></el-input>
								</td>
							</tr> -->
						</tbody>
					</table>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="settlement_steps1 = false">取 消</el-button>
					<el-button type="primary" @click="Add" :loading="btnLoading1">确 定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="薪资结算" :visible.sync="settlement_steps2" width="50%">
				<div>
					<span>用户名：{{ contentList.userName }}</span>
					<span style="margin-left:40px;">薪资月份：{{ contentList.month }}</span>
					<span style="margin-left:40px;">提成结算时间：{{ contentList.cycle }}</span>
				</div>
				<div style="margin-top:15px;">
					<el-table :data="contentList.sellerList" border style="width: 100%">
						<el-table-column align="center" prop="roleName" label="角色名"></el-table-column>
						<el-table-column align="center" prop="shop_name" label="店铺名"></el-table-column>
						<el-table-column align="center" prop="totalProfit" label="利润"></el-table-column>
						<el-table-column align="center" prop="openRefund" label="未结退款"></el-table-column>
						<el-table-column align="center" prop="finalProfit" label="最终利润"></el-table-column>
					</el-table>
				</div>
				<div style="margin-top:15px;">
					<el-table :data="contentList.userRoleVoList" border style="width: 100%">
						<el-table-column align="center" prop="roleName" label="角色名"></el-table-column>
						<el-table-column align="center" prop="buyerAccountFee" label="手动添加费用(成本)"></el-table-column>
					</el-table>
				</div>

				<div style="margin-top:15px;">
					<label>结算提成：</label>
					<el-input style="width:100px;margin:10px;" v-model="wage.commission"></el-input>
				</div>

				<div style="margin-top:15px;" @paste="handlePaste">
					<table border="0" cellpadding="0" width="100%" class="table-box">
						<tbody>
							<tr>
								<th v-for="(h, index) in wageFields" :key="index">{{ h.label }}</th>
							</tr>
							<tr>
								<td v-for="h in wageFields" :key="h.prop">
									<el-input v-model="wage[h.prop]" @focus="setActiveField(h.prop)"></el-input>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div style="margin-top:15px;">
					<label style="line-height:50px;">备注</label>
					<el-input type="textarea" :rows="3" v-model="wage.remarks"></el-input>
				</div>

				<div style="margin-top:15px">
					<el-row type="flex">
						<upload-excel-component :on-success="handleSuccess" />
						<el-button size="mini" @click="downloadTemplate" style="margin-left:10px">下载模板</el-button>
					</el-row>
					<el-table :data="listTable" border style="margin-top:15px">
						<el-table-column prop="sellerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="orderProfit" label="订单利润" align="center"></el-table-column>
						<el-table-column prop="shopRent" label="店铺租金" align="center"></el-table-column>
						<el-table-column prop="orderReturnFee" label="订单退款费用" align="center"></el-table-column>
						<el-table-column prop="redeliveryFee" label="广告费用" align="center"></el-table-column>
						<el-table-column prop="frozenCost" label="冻结成本" align="center"></el-table-column>
						<el-table-column prop="shopProfit" label="店铺利润" align="center"></el-table-column>
						<el-table-column label="操作" align="center" width="100">
							<template slot-scope="scope">
								<el-button type="text" @click="deleteTableItem1(scope.$index)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="Save">保存</el-button>
				</span>
			</el-dialog>

			<el-dialog title="薪资结算" :visible.sync="settlement_edit" width="50%">
				<div>
					<span>用户名：{{ valData.userName }}</span>
					<span style="margin-left:40px;">薪资月份：{{ valData.salaryMonth }}</span>
					<span style="margin-left:40px;">提成结算时间：{{ valData.cycle }}</span>
				</div>
				<div style="margin-top:15px;">
					<el-table :data="valData.userProfitList" border style="width: 100%">
						<el-table-column align="center" prop="roleName" label="角色名"></el-table-column>
						<el-table-column align="center" prop="sellerName" label="店铺名"></el-table-column>
						<el-table-column align="center" prop="totalProfit" label="利润"></el-table-column>
						<el-table-column align="center" prop="openRefund" label="未结退款"></el-table-column>
						<el-table-column align="center" prop="finalProfit" label="最终利润"></el-table-column>
					</el-table>
				</div>

				<div style="margin-top:15px;">
					<label>结算提成：</label>
					<el-input style="width:100px;margin:10px;" v-model="wage1.commission"></el-input>
				</div>

				<div style="margin-top:15px;" @paste="handlePaste1">
					<table border="0" cellpadding="0" width="100%" class="table-box">
						<tbody>
							<tr>
								<th v-for="(h, index) in wageFields" :key="index">{{ h.label }}</th>
							</tr>
							<tr>
								<td v-for="h in wageFields" :key="h.prop">
									<el-input v-model="wage1[h.prop]" @focus="setActiveField1(h.prop)"></el-input>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div style="margin-top:15px;">
					<label style="line-height:50px;">备注</label>
					<el-input type="textarea" :rows="3" v-model="wage1.remarks"></el-input>
				</div>

				<div style="margin-top:15px">
					<el-row type="flex" v-if="listTable1.length != 0">
						<el-button type="primary" size="mini" @click="increaseInfo">增加一条</el-button>
						<el-button type="danger" size="mini" @click="batchTableItem">批量删除</el-button>
						<!-- <upload-excel-component :on-success="handleSuccess" />
						<el-button size="mini" @click="downloadTemplate" style="margin-left:10px">下载模板</el-button> -->
					</el-row>
					<el-row type="flex" v-else>
						<el-button type="primary" style="margin-right:10px" size="mini"
							@click="increaseInfo">增加一条</el-button>
						<upload-excel-component :on-success="handleSuccess" />
						<el-button size="mini" @click="downloadTemplate" style="margin-left:10px">下载模板</el-button>
					</el-row>
					<el-table :data="listTable1" @selection-change="handleSelectionChange" border
						style="margin-top:15px">
						<el-table-column align="center" type="selection"></el-table-column>
						<el-table-column prop="sellerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="orderProfit" label="订单利润" align="center"></el-table-column>
						<el-table-column prop="shopRent" label="店铺租金" align="center"></el-table-column>
						<el-table-column prop="orderReturnFee" label="订单退款费用" align="center"></el-table-column>
						<el-table-column prop="redeliveryFee" label="广告费用" align="center"></el-table-column>
						<el-table-column prop="frozenCost" label="冻结成本" align="center"></el-table-column>
						<el-table-column prop="shopProfit" label="店铺利润" align="center"></el-table-column>
						<el-table-column label="操作" align="center" width="124">
							<template slot-scope="scope">
								<el-row type="flex">
									<el-button type="primary" @click="editTableItem(scope.row)"
										icon="el-icon-edit"></el-button>
									<el-button type="danger" icon="el-icon-delete"
										@click="deleteTableItem(scope.row)"></el-button>
								</el-row>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="EditSub">提交</el-button>
					<el-button type="danger" @click="EditDel">删除</el-button>
					<el-button type="primary" @click="EditSave">保存</el-button>
				</span>

				<el-dialog title="创建信息" width="600px" :visible.sync="dialogInnerVisible" top="4vh" append-to-body>
					<el-form label-width="100px" ref="dialogInnerForm" :model="dialogInnerForm">
						<el-form-item label="姓名">
							<el-input v-model="dialogInnerForm.sellerName"></el-input>
						</el-form-item>
						<el-form-item label="订单利润">
							<el-input v-model="dialogInnerForm.orderProfit"></el-input>
						</el-form-item>
						<el-form-item label="店铺租金">
							<el-input v-model="dialogInnerForm.shopRent"></el-input>
						</el-form-item>
						<el-form-item label="订单退款费用">
							<el-input v-model="dialogInnerForm.orderReturnFee"></el-input>
						</el-form-item>
						<el-form-item label="广告费用">
							<el-input v-model="dialogInnerForm.redeliveryFee"></el-input>
						</el-form-item>
						<el-form-item label="冻结成本">
							<el-input v-model="dialogInnerForm.frozenCost"></el-input>
						</el-form-item>
						<el-form-item label="店铺利润">
							<el-input v-model="dialogInnerForm.shopProfit"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer">
						<el-button type="primary" @click="addIncrease">提 交</el-button>
					</div>
				</el-dialog>
				<el-dialog title="创建信息" width="600px" :visible.sync="dialogInnerVisible1" top="4vh" append-to-body>
					<el-form label-width="100px" ref="dialogInnerForm" :model="dialogInnerForm">
						<el-form-item label="姓名">
							<el-input v-model="dialogInnerForm.sellerName1"></el-input>
						</el-form-item>
						<el-form-item label="订单利润">
							<el-input v-model="dialogInnerForm.orderProfit1"></el-input>
						</el-form-item>
						<el-form-item label="店铺租金">
							<el-input v-model="dialogInnerForm.shopRent1"></el-input>
						</el-form-item>
						<el-form-item label="订单退款费用">
							<el-input v-model="dialogInnerForm.orderReturnFee1"></el-input>
						</el-form-item>
						<el-form-item label="广告费用">
							<el-input v-model="dialogInnerForm.redeliveryFee1"></el-input>
						</el-form-item>
						<el-form-item label="冻结成本">
							<el-input v-model="dialogInnerForm.frozenCost1"></el-input>
						</el-form-item>
						<el-form-item label="店铺利润">
							<el-input v-model="dialogInnerForm.shopProfit1"></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer">
						<el-button type="primary" @click="addIncrease1">提 交</el-button>
					</div>
				</el-dialog>
			</el-dialog>

			<el-dialog title="薪资结算" :visible.sync="settlement_edit1" width="50%">
				<div>
					<span>用户名：{{ valData.userName }}</span>
					<span style="margin-left:40px;">薪资月份：{{ valData.salaryMonth }}</span>
					<span style="margin-left:40px;">提成结算时间：{{ valData.cycle }}</span>
				</div>
				<div style="margin-top:15px;">
					<el-table :data="valData.userProfitList" border style="width: 100%">
						<el-table-column align="center" prop="roleName" label="角色名"></el-table-column>
						<el-table-column align="center" prop="sellerName" label="店铺名"></el-table-column>
						<el-table-column align="center" prop="totalProfit" label="利润"></el-table-column>
						<el-table-column align="center" prop="openRefund" label="未结退款"></el-table-column>
						<el-table-column align="center" prop="finalProfit" label="最终利润"></el-table-column>
					</el-table>
				</div>

				<div style="margin-top:15px;">
					<label>结算提成：</label>
					<span>{{ wage1.commission }}</span>
				</div>

				<div style="margin-top:15px;">
					<table border="0" cellpadding="0" width="100%" class="table-box">
						<tbody>
							<tr>
								<th v-for="(h, index) in wageFields" :key="index">{{ h.label }}</th>
							</tr>
							<tr>
								<td v-for="h in wageFields" :key="h.prop">
									{{ wage1[h.prop] }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div style="margin-top:15px;">
					<label style="line-height:50px;">备注</label>
					<el-input type="textarea" :rows="3" v-model="wage1.remarks" disabled></el-input>
				</div>
				<div style="margin-top:15px">
					<el-table :data="listTable1" border style="margin-top:15px">
						<el-table-column prop="sellerName" label="姓名" align="center"></el-table-column>
						<el-table-column prop="orderProfit" label="订单利润" align="center"></el-table-column>
						<el-table-column prop="shopRent" label="店铺租金" align="center"></el-table-column>
						<el-table-column prop="orderReturnFee" label="订单退款费用" align="center"></el-table-column>
						<el-table-column prop="redeliveryFee" label="广告费用" align="center"></el-table-column>
						<el-table-column prop="frozenCost" label="冻结成本" align="center"></el-table-column>
						<el-table-column prop="shopProfit" label="店铺利润" align="center"></el-table-column>
					</el-table>
				</div>
				<span slot="footer" class="dialog-footer" v-show="isShow" v-if="this.valData.state == 2">
					<el-button type="primary" @click="through">确认发放</el-button>
					<el-button type="danger" @click="nothrough">不予通过</el-button>
				</span>
			</el-dialog>

			<div class="page">
				<el-pagination style="margin-right:200px;" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[50, 100, 200, 400]"
					:page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
					:total="total"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../api/api/api'
import UploadExcelComponent from '@/components/UploadExcel/index.vue'
export default {
	name: 'CommissionSettlementDetails',
	data() {
		return {
			str: '',
			dialogInnerForm: {},
			tableData: [],
			listTable: [],
			listTable1: [],
			sellerId: '',
			RateList: [],
			arr: [],
			RateList1: [],
			loading: false,
			dialogInnerVisible: false,
			dialogInnerVisible1: false,
			settlement_steps1: false,
			settlement_steps2: false,
			settlement_edit: false,
			settlement_edit1: false,
			isShow: '',
			btnLoading1: false,

			currentPage: 1,
			pagesize: 50,
			size: 50,
			total: 0,

			dialogInnerForm: {
				sellerName: '',
				orderProfit: '',
				shopRent: '',
				orderReturnFee: '',
				redeliveryFee: '',
				frozenCost: '',
				shopProfit: '',

				sellerName1: '',
				orderProfit1: '',
				shopRent1: '',
				orderReturnFee1: '',
				redeliveryFee1: '',
				frozenCost1: '',
				shopProfit1: '',
			},
			staff: [
				{ name: '未提交', value: 1 },
				{ name: '未审核', value: 2 },
				{ name: '已发放', value: 3 },
				{ name: '审核失败', value: 4 },
			],
			month: [
				{ name: '1月', value: 1 },
				{ name: '2月', value: 2 },
				{ name: '3月', value: 3 },
				{ name: '4月', value: 4 },
				{ name: '5月', value: 5 },
				{ name: '6月', value: 6 },
				{ name: '7月', value: 7 },
				{ name: '8月', value: 8 },
				{ name: '9月', value: 9 },
				{ name: '10月', value: 10 },
				{ name: '11月', value: 11 },
				{ name: '12月', value: 12 },
			],
			userList: [],
			ruleForm: {
				type: '', //选择状态
				starttime: '', //开始时间
				endtime: '', //结束时间
				input: '', //搜索框
				salaryMonth: '', //月份
			},
			Setform: {
				starttime: '', //开始时间
				endtime: '', //结束时间
				salaryMonth: '', //月份
				settlementTime: '', //结算日
				user: '', //用户
			},
			pickerOptions: {
				shortcuts: [
					{
						text: '本月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate()
						},
					},
					{
						text: '上一月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-1)
						},
					},
					{
						text: '上两月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-2)
						},
					},
					{
						text: '上三月',
						onClick: (picker) => {
							const date = new Date()
							picker.$emit('pick', date)
							this.calculationDate(-3)
						},
					},
				],
			},
			contentList: '',
			wage: {
				basicWage: '', //基本工资
				jobsWage: '', //岗位津贴
				perfectAttendanceAward: '', //全勤奖
				incentiveBonus: '', //激励奖金
				groupCommission: '', //小组提成
				supervisorCommission: '', //提成
				otherSubsidies: '', //其他补贴
				financialReimbursement: '', //财务报销
				reissue: '', //补发
				operationalDeduction: '', //运营扣款
				attendanceDeduction: '', //考勤扣款
				otherDeduction: '', //职工保险代缴扣款

				commission: '', //结算提成
				remarks: '', //备注
			},
			wage1: {
				basicWage: '', //基本工资
				jobsWage: '', //岗位津贴
				perfectAttendanceAward: '', //全勤奖
				incentiveBonus: '', //激励奖金
				groupCommission: '', //小组提成
				supervisorCommission: '', //提成
				otherSubsidies: '', //其他补贴
				financialReimbursement: '', //财务报销
				reissue: '', //补发
				operationalDeduction: '', //运营扣款
				attendanceDeduction: '', //考勤扣款
				otherDeduction: '', //职工保险代缴扣款

				commission: '', //结算提成
				remarks: '', //备注
			},
			valData: '',
			activeField: '',
			activeField1: '',
			wageFields: [
				{ label: "基本工资", prop: "basicWage" },
				{ label: "学历津贴", prop: "incentiveBonus" },
				{ label: "岗位工资", prop: "financialReimbursement" },
				{ label: "全勤奖", prop: "perfectAttendanceAward" },
				{ label: "奖励", prop: "otherSubsidies" },
				{ label: "主管提成", prop: "supervisorCommission" },
				{ label: "小组提成", prop: "groupCommission" },
				{ label: "补助", prop: "jobsWage" },
				{ label: "补发", prop: "reissue" },

				{ label: "运营扣款", prop: "operationalDeduction" },
				{ label: "考勤扣款", prop: "attendanceDeduction" },
				{ label: "职工保险代缴扣款", prop: "otherDeduction" }
			],
		}
	},
	components: {
		UploadExcelComponent,
	},
	mounted() {},
	created() {
		this.getStr();
		this.calculationDate(-3)
		this.exchangeRate()
		this.search()
	},
	methods: {
		getStr() {
			this.str = JSON.parse(localStorage.getItem('role'))
		},
		setActiveField(field) {
			this.activeField = field;
		},
		handlePaste(event) {
			event.preventDefault();
			const clipboardData = event.clipboardData || window.clipboardData;
			const pastedData = clipboardData.getData('Text');

			const values = pastedData.trim().split('\t');

			const keys = this.wageFields.map(item => item.prop);

			const startIndex = keys.indexOf(this.activeField);
			if (startIndex === -1) {
				this.$message.warning('请先点击一个输入框再粘贴');
				return;
			}

			for (let i = 0; i < values.length; i++) {
				const field = keys[startIndex + i];
				if (field) {
					let val = values[i].trim();
					if(val){
						if (startIndex + i >= 9){
							val = -(+val)
						}
					}else{
						val = 0
					}
					this.$set(this.wage, field, val);
				} else {
					break;
				}
			}
		},
		setActiveField1(field) {
			this.activeField1 = field;
		},
		handlePaste1(event) {
			event.preventDefault();
			const clipboardData = event.clipboardData || window.clipboardData;
			const pastedData = clipboardData.getData('Text');

			const values = pastedData.trim().split('\t');

			const keys = this.wageFields.map(item => item.prop);

			const startIndex = keys.indexOf(this.activeField1);
			if (startIndex === -1) {
				this.$message.warning('请先点击一个输入框再粘贴');
				return;
			}

			for (let i = 0; i < values.length; i++) {
				const field = keys[startIndex + i];
				if (field) {
					let val = values[i].trim();
					if (val) {
						if (startIndex + i >= 9) {
							val = -(+val)
						}
					} else {
						val = 0
					}
					this.$set(this.wage1, field, val);
				} else {
					break;
				}
			}
		},
		handleSelectionChange(val) {
			console.log(val)
			var arr = val.map((item) => item.id)
			this.arr = arr
			console.log(arr)
		},
		deleteTableItem1(row) {
			console.log(row)
			this.listTable.splice(row, 1)
		},
		addIncrease() {
			const paramasData = {
				uid: this.valData.uid,
				payrollId: this.valData.id,
				sellerName: this.dialogInnerForm.sellerName,
				orderProfit: this.dialogInnerForm.orderProfit,
				shopRent: this.dialogInnerForm.shopRent,
				orderReturnFee: this.dialogInnerForm.orderReturnFee,
				redeliveryFee: this.dialogInnerForm.redeliveryFee,
				frozenCost: this.dialogInnerForm.frozenCost,
				shopProfit: this.dialogInnerForm.shopProfit,
			}
			ajaxPost(
				Baseurl + 'commissionController/insertCommission',
				paramasData
			).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('新增成功！')
					this.dialogInnerVisible = false
					this.Refresh()
				} else {
					this.$message.error('新增失败！')
				}
			})
		},
		Refresh() {
			const paramsData = {
				uid: this.valData.uid,
				payrollId: this.valData.id,
			}
			ajaxPost(
				Baseurl + 'commissionController/selectCommissionList',
				paramsData
			).then((res) => {
				if (res.data.code == 200) {
					this.listTable1 = res.data.data
				} else {
					this.$message.error('新增失败！')
				}
			})
		},
		addIncrease1() {
			const paramasData = {
				id: this.sellerId,
				sellerName: this.dialogInnerForm.sellerName1,
				orderProfit: this.dialogInnerForm.orderProfit1,
				shopRent: this.dialogInnerForm.shopRent1,
				orderReturnFee: this.dialogInnerForm.orderReturnFee1,
				redeliveryFee: this.dialogInnerForm.redeliveryFee1,
				frozenCost: this.dialogInnerForm.frozenCost1,
				shopProfit: this.dialogInnerForm.shopProfit1,
			}
			ajaxPost(
				Baseurl + 'commissionController/updateCommission',
				paramasData
			).then((res) => {
				if (res.data.code == 200) {
					this.$message.success('编辑成功！')
					this.dialogInnerVisible1 = false
					this.Refresh()
				} else {
					this.$message.error('编辑失败！')
				}
			})
		},
		increaseInfo() {
			this.dialogInnerVisible = true
		},
		editTableItem(row) {
			console.log(row)
			this.dialogInnerVisible1 = true
			this.sellerId = row.id
			this.dialogInnerForm.sellerName1 = row.sellerName
			this.dialogInnerForm.orderProfit1 = row.orderProfit
			this.dialogInnerForm.shopRent1 = row.shopRent
			this.dialogInnerForm.orderReturnFee1 = row.orderReturnFee
			this.dialogInnerForm.redeliveryFee1 = row.redeliveryFee
			this.dialogInnerForm.frozenCost1 = row.frozenCost
			this.dialogInnerForm.shopProfit1 = row.shopProfit
		},
		deleteTableItem(row) {
			console.log(row)
			this.$confirm('是否删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var arr = []
					arr.push(row.id)
					console.log(arr)
					const paramsData = {
						ids: arr,
					}
					ajaxPost(
						Baseurl + 'commissionController/deleteCommission',
						paramsData
					).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								message: '删除成功',
								type: 'success',
							})
							this.dialogInnerVisible1 = false
							this.Refresh()
						} else {
							this.$message.error(res.data.data)
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		batchTableItem() {
			if (!this.arr.length) {
				this.$message.warning('请至少选择一条!')
				return
			}
			this.$confirm('是否要批量删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					const paramsData = {
						ids: this.arr,
					}
					ajaxPost(
						Baseurl + 'commissionController/deleteCommission',
						paramsData
					).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								message: '批量删除成功',
								type: 'success',
							})
							this.dialogInnerVisible1 = false
							this.Refresh()
						} else {
							this.$message.error(res.data.data)
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		handleSuccess({ results }) {
			const result = results.every((item) => {
				// console.log(item)
				// console.log(typeof item['店铺利润'])
				if (item['姓名'] == null) return false
				if (item['订单利润'] == null) return false
				if (item['店铺租金'] == null) return false
				if (item['订单退款费用'] == null) return false
				if (item['广告费用'] == null) return false
				if (item['冻结成本'] == null) return false
				if (
					item['店铺利润'] == null ||
					typeof item['店铺利润'] != 'number'
				)
					return false
				return true
			})
			if (!result) {
				this.$message.warning('请将数据填写完整')
				return
			}
			if (this.settlement_edit) {
				this.listTable1 = results.map((item) => {
					return {
						sellerName: item['姓名'],
						orderProfit: item['订单利润'],
						shopRent: item['店铺租金'],
						orderReturnFee: item['订单退款费用'],
						redeliveryFee: item['广告费用'],
						frozenCost: item['冻结成本'],
						shopProfit: item['店铺利润'],
					}
				})
				// console.log(JSON.parse(JSON.stringify(this.listTable1)))
				// return
				let API = Baseurl + 'commissionController/commissionAdd'
				let obj = {
					uid: this.valData.uid,
					payrollId: this.valData.id,
					commissionList: this.listTable1,
				}
				ajaxPost(API, obj).then((res) => {
					// console.log(res)
					if (res.data.code == 200) {
						let API =
							Baseurl +
							'commissionController/selectCommissionList'
						ajaxPost(API, {
							uid: this.valData.uid,
							payrollId: this.valData.id,
						}).then((res) => {
							// console.log(res)
							if (res.data.code == 200) {
								this.listTable1 = res.data.data
							}
						})
					}
				})
			} else {
				this.listTable = results.map((item) => {
					return {
						sellerName: item['姓名'],
						orderProfit: item['订单利润'],
						shopRent: item['店铺租金'],
						orderReturnFee: item['订单退款费用'],
						redeliveryFee: item['广告费用'],
						frozenCost: item['冻结成本'],
						shopProfit: item['店铺利润'],
					}
				})
			}
		},
		downloadTemplate() {
			const aEle = document.createElement('a')
			aEle.href =
				'https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/%E8%96%AA%E8%B5%84%E6%8F%90%E6%88%90.xlsx'
			aEle.click()
			this.$message.success('正在下载...')
		},
		open() {
			let date = new Date()
			this.settlement_steps1 = true
			this.Setform.settlementTime = date.getDate() //获取当前日(1-31)
			this.user()
			this.EditRateList()
		},
		user() {
			this.getStr();
			var obj = { companyId: this.str.company_id }
			ajaxPost(
				Baseurl + 'userControllers/selectUserListByCompanyId',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.userList = res.data.data
				}
			})
		},
		EditRateList() {
			this.getStr();
			const str = localStorage.getItem('localRateListData');
			let localRateListData = {}
			if(str){
				localRateListData = JSON.parse(str);
				if(Date.now() > localRateListData.time){ //过期了
					localStorage.removeItem('localRateListData');
					ajaxPost(Baseurl + 'rateController/getAllRate1').then((res) => {
						if (res.data.code == 200) {
							this.RateList1 = res.data.data
						}
					})
				}else{
					this.RateList1 = localRateListData.list;
				}
			}else{
				ajaxPost(Baseurl + 'rateController/getAllRate1').then((res) => {
					if (res.data.code == 200) {
						this.RateList1 = res.data.data
					}
				})
			}
		},
		exchangeRate() {
			ajaxPost(Baseurl + 'rateController/getAllRate').then((res) => {
				if (res.data.code == 200) {
					this.RateList = res.data.data
				}
			})
		},
		search2() {
			this.currentPage = 1
			this.search()
		},
		search() {
			this.getStr();
			var obj = {
				companyId: this.str.company_id,
				startTime1: this.ruleForm.starttime,
				endTime1: this.ruleForm.endtime,
				searchStr: this.ruleForm.input,
				state: this.ruleForm.type,
				salaryMonth: this.ruleForm.salaryMonth,
				page: this.currentPage,
				size: this.size,
			}
			this.loading = true
			ajaxPost(Baseurl + 'payrollController/selectPayrollInfo', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.tableData = res.data.data.list
						this.total = res.data.data.total
					}
					this.loading = false
				}
			)
		},
		searchReset() {
			this.currentPage = 1
			this.ruleForm.type = ''
			this.ruleForm.starttime = ''
			this.ruleForm.endtime = ''
			this.ruleForm.input = ''
			this.ruleForm.salaryMonth = ''
			this.search()
		},
		Add() {
			this.getStr();
			// console.log(this.Setform)
			if (this.Setform.salaryMonth == '') {
				this.$message.error('请选择月份')
				return
			} else if (this.Setform.user == '') {
				this.$message.error('请选择用户')
				return
			} else if (this.Setform.settlementTime == '') {
				this.$message.error('请填写结算日期')
				return
			} else {
				this.btnLoading1 = true
				var obj = {
					uid: this.Setform.user,
					companyId: this.str.company_id,
					startTime: this.Setform.starttime,
					endTime: this.Setform.endtime,
					rateList: this.RateList1,
					number: this.Setform.settlementTime,
					month: this.Setform.salaryMonth,
				}
				ajaxPost(
					Baseurl +
						'payrollController/getSellerTotalPerformanceByUid',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.contentList = res.data.data
						this.settlement_steps2 = true
					} else {
						this.$message.error(res.data.data)
					}
					this.btnLoading1 = false;
					const localRateListData = {
						time: Date.now() + 604800000,
						list: this.RateList1
					}
					localStorage.setItem('localRateListData', JSON.stringify(localRateListData));
				})
			}
		},
		Save() {
			this.getStr();
			if (this.wage.commission == '') {
				this.$message.error('结算提成不能为空！')
			} else if (this.wage.basicWage == '') {
				this.$message.error('基本工资不能为空！')
			} else if (this.wage.perfectAttendanceAward == '') {
				this.$message.error('全勤奖不能为空！')
			} else if (this.wage.incentiveBonus == '') {
				this.$message.error('激励奖金不能为空！')
			} else if (this.wage.jobsWage == '') {
				this.$message.error('岗位津贴不能为空！')
			} else if (this.wage.groupCommission == '') {
				this.$message.error('小组提成不能为空！')
			} else if (this.wage.supervisorCommission == '') {
				this.$message.error('提成不能为空！')
			} else if (this.wage.otherSubsidies == '') {
				this.$message.error('其他补贴不能为空！')
			} else if (this.wage.financialReimbursement == '') {
				this.$message.error('财务报销不能为空！')
			} else if (this.wage.reissue == '') {
				this.$message.error('补发不能为空！')
			} else if (this.wage.operationalDeduction == '') {
				this.$message.error('运营扣款不能为空！')
			} else if (this.wage.attendanceDeduction == '') {
				this.$message.error('考勤扣款不能为空！')
			} else if (this.wage.otherDeduction == '') {
				this.$message.error('其他扣款不能为空！')
			} else {
				var obj = {
					uid: this.Setform.user,
					companyId: this.str.company_id,
					startTime: this.Setform.starttime,
					endTime: this.Setform.endtime,
					salaryMonth: this.Setform.salaryMonth,
					commissionList: this.listTable,
					basicWage: this.wage.basicWage,
					jobsWage: this.wage.jobsWage,
					perfectAttendanceAward: this.wage.perfectAttendanceAward,
					incentiveBonus: this.wage.incentiveBonus,
					groupCommission: this.wage.groupCommission,
					supervisorCommission: this.wage.supervisorCommission,
					otherSubsidies: this.wage.otherSubsidies,
					financialReimbursement: this.wage.financialReimbursement,
					reissue: this.wage.reissue,
					operationalDeduction: this.wage.operationalDeduction,
					attendanceDeduction: this.wage.attendanceDeduction,
					otherDeduction: this.wage.otherDeduction,

					commission: this.wage.commission,
					remarks: this.wage.remarks,
					sellerList: this.contentList.sellerList,
				}
				ajaxPost(
					Baseurl + 'payrollController/insertPayrollInfo',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: '保存成功',
							type: 'success',
						})
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
					this.Setform.salaryMonth = ''
					this.Setform.user = ''
					// this.Setform.settlementTime = ''

					this.wage.commission = ''
					this.wage.remarks = ''

					this.wage.basicWage = ''
					this.wage.jobsWage = ''
					this.wage.perfectAttendanceAward = ''
					this.wage.incentiveBonus = ''
					this.wage.groupCommission = ''
					this.wage.supervisorCommission = ''
					this.wage.otherSubsidies = ''
					this.wage.financialReimbursement = ''
					this.wage.reissue = ''
					this.wage.operationalDeduction = ''
					this.wage.attendanceDeduction = ''
					this.wage.otherDeduction = ''

					this.settlement_steps2 = false
				})
			}
		},
		//编辑
		Edit(val) {
			this.getStr();
			if (
				this.str.system == 1 ||
				this.str.superDepartmentName == '财务部'
			) {
				this.isShow = true
			} else {
				this.isShow = false
			}

			if (val.state == 1 || val.state == 4) {
				this.settlement_edit = true
			} else {
				this.settlement_edit1 = true
			}

			this.valData = val
			this.listTable1 = val.commissionList
			this.wage1.commission = val.commission
			this.wage1.remarks = val.remarks
			this.wage1.basicWage = val.basicWage
			this.wage1.jobsWage = val.jobsWage
			this.wage1.perfectAttendanceAward = val.perfectAttendanceAward
			this.wage1.incentiveBonus = val.incentiveBonus
			this.wage1.groupCommission = val.groupCommission
			this.wage1.supervisorCommission = val.supervisorCommission
			this.wage1.otherSubsidies = val.otherSubsidies
			this.wage1.financialReimbursement = val.financialReimbursement
			this.wage1.reissue = val.reissue
			this.wage1.operationalDeduction = val.operationalDeduction
			this.wage1.attendanceDeduction = val.attendanceDeduction
			this.wage1.otherDeduction = val.otherDeduction
		},
		//编辑保存
		EditSave() {
			var obj = {
				id: this.valData.id,

				basicWage: this.wage1.basicWage,
				jobsWage: this.wage1.jobsWage,
				perfectAttendanceAward: this.wage1.perfectAttendanceAward,
				incentiveBonus: this.wage1.incentiveBonus,
				groupCommission: this.wage1.groupCommission,
				supervisorCommission: this.wage1.supervisorCommission,
				otherSubsidies: this.wage1.otherSubsidies,
				financialReimbursement: this.wage1.financialReimbursement,
				reissue: this.wage1.reissue,
				operationalDeduction: this.wage1.operationalDeduction,
				attendanceDeduction: this.wage1.attendanceDeduction,
				otherDeduction: this.wage1.otherDeduction,

				commission: this.wage1.commission,
				remarks: this.wage1.remarks,
			}
			ajaxPost(Baseurl + 'payrollController/updatePayrollInfo', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.$message({
							message: '保存成功',
							type: 'success',
						})
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
					this.settlement_edit = false
				}
			)
		},
		//编辑删除
		EditDel() {
			this.$confirm('是否删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				var obj = {
					id: this.valData.id,
					state: 0,
				}
				ajaxPost(
					Baseurl + 'payrollController/deletePayrollInfo',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: '删除成功',
							type: 'success',
						})
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
					this.settlement_edit = false
				})
			})
		},
		//编辑提交
		EditSub() {
			this.getStr();
			this.$confirm('是否提交？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				var obj = {
					id: this.valData.id,
					signRid: this.str.rid,
					endTime: this.valData.endTime,
					uid: this.valData.uid,
					companyId: this.str.company_id,
				}
				ajaxPost(
					Baseurl + 'payrollController/submitPayrollInfo',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: '提交成功',
							type: 'success',
						})
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
					this.settlement_edit = false
				})
			})
		},
		through() {
			this.getStr();
			this.$confirm('是否确认发放', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				var obj = {
					state: 3,
					signRid: this.str.rid,
					id: this.valData.id,
					endTime: this.valData.endTime,
					uid: this.valData.uid,
					companyId: this.str.company_id,
				}
				ajaxPost(
					Baseurl + 'payrollController/reviewPayrollInfo',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: '发放成功',
							type: 'success',
						})
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
					this.settlement_edit1 = false
				})
			})
		},
		nothrough() {
			this.getStr();
			this.$confirm('是否不予通过', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(() => {
				var obj = {
					state: 4,
					signRid: this.str.rid,
					id: this.valData.id,
					endTime: this.valData.endTime,
					uid: this.valData.uid,
					companyId: this.str.company_id,
				}
				ajaxPost(
					Baseurl + 'payrollController/reviewPayrollInfo',
					obj
				).then((res) => {
					if (res.data.code == 200) {
						this.$message({
							message: '不予通过',
							type: 'success',
						})
						this.search()
					} else {
						this.$message.error(res.data.data)
					}
					this.settlement_edit1 = false
				})
			})
		},
		calculationDate(type = 0) {
			const date = new Date()
			const year = date.getFullYear()
			const month = date.getMonth() + 1
			const day = date.getDay()
			// this.Setform.starttime = `${year}-${month + type}-01 00:00:00`
			// console.log(this.Setform.starttime)

			const prevStamp =
				new Date(year, month + type, day).getTime() -
				3600 * 1000 * 24 * day
			const prevMonth = `${new Date(prevStamp).getFullYear()}-${new Date(
				prevStamp
			).getMonth() + 1}-${new Date(prevStamp).getDate()}`
			const prevMonth1 = `${new Date(prevStamp).getFullYear()}-${new Date(
				prevStamp
			).getMonth() + 1}`

			this.Setform.starttime = `${prevMonth1}-01 00:00:00`
			console.log(this.Setform.starttime)
			this.Setform.endtime = `${prevMonth} 23:59:59`
		},
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
			this.size = val
			this.search()
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.currentPage = val
			this.search()
		},
	},
}
</script>

<style lang="scss">
.CommissionSettlementDetails {
	width: 98%;
	margin-bottom: 50px;
	overflow: hidden;
	.CommissionSettlementDetails-content {
		margin-top: 20px;
		.el-form-item {
			overflow: hidden;
			width: 20%;
			margin-bottom: 18px;
			float: left;
		}
		// .searchInput .el-form-item__content{
		//     margin-left: 0px!important;
		// }
		.Reportform_tiem {
			overflow: hidden;
			border-top: 1px solid #eee;
			padding: 15px 0;
			.search-result-text {
				font-size: 14px;
				color: #606266;
				padding: 0;
			}
			.el-radio-group {
				display: inline-block;
				line-height: 1;
				vertical-align: middle;
				font-size: 0;
				margin-left: 20px;
			}
		}
		.paging {
			width: 40%;
			margin: 20px auto;
		}
		.table-box {
			border-collapse: collapse;
		}
		.layout_table {
			table-layout: fixed;
		}
		.RoteName {
			color: #909399 !important;
			font-size: 16px !important;
			font-weight: bold;
		}
		.table-box th {
			text-align: center;
			line-height: 36px;
			border: 1px solid #ebeef5;
			color: #909399;
			font-size: 14px;
		}
		.table-box td {
			text-align: center;
			line-height: 36px;
			border: 1px solid #ebeef5;
			color: #909399;
			font-size: 14px;
			width: 8%;
			word-wrap: break-word;
			padding: 0 4px;
		}
		.page {
			position: fixed;
			width: 100%;
			bottom: 0;
			background-color: white;
			display: flex;
			justify-content: center;
			align-items: center;
			height: 50px;
		}
	}
}
</style>
